const REVOKE_DELAY_MS = 40_000

/**
 * @param {{ fileName: string, content?: BlobPart, mimeType?: string, file?: Blob }} params
 */
export const downloadFile = ({ fileName, content, mimeType, file }) => {
  if (file && content) {
    throw new Error('Only one of file or content can be provided')
  }
  let finalFile = file

  if (content) {
    const fileOptions = mimeType ? { type: mimeType } : {}
    finalFile = new Blob([content], fileOptions)
  }

  const url = URL.createObjectURL(finalFile)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  // Revoking synchronously can cancel the download in some browsers before it reads the blob.
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS)
}
